import { styleConstants, themeConstants } from '@paywithextend/components'
import React from 'react'
import { useDispatch } from 'react-redux'
import SvgClose from 'src/components/Svgs/SvgClose'
import { closeModal } from 'src/navigation/Lnk'
import { css } from 'styled-components'

export enum CloseButtonDesigns {
  DarkOnLight = 'dark-on-light',
  LightOnDark = 'light-on-dark',
  RedLightOnDark = 'red-light-on-dark',
  DisabledDarkOnLight = 'disabled-dark-on-light',
}

interface CloseButtonProps {
  className?: string
  id?: string
  design: CloseButtonDesigns
  isRightAligned?: boolean
  onClick?: () => void
  suppressCloseModalAction?: boolean
}

const CloseButton: React.FC<CloseButtonProps> = (props): React.ReactElement => {
  const dispatch = useDispatch()
  const onButtonClick = (): void => {
    if (!props.suppressCloseModalAction) {
      dispatch(closeModal())
    }
  }

  return (
    <div
      className={props.className}
      onClick={onButtonClick}
      onKeyPress={onButtonClick}
      role="button"
      tabIndex={0}
      aria-label={'close-button'}
      css={css`
        height: 24px;
        width: 24px;
        position: relative;
      `}
    >
      <div
        onClick={props.onClick}
        onKeyPress={props.onClick}
        role="button"
        tabIndex={0}
        aria-label={'hoverable container'}
        css={css`
          height: 36px;
          width: 36px;
          position: absolute;
          cursor: pointer;
          top: -6px;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: ${styleConstants.borderRadius.button};
          left: -6px;

          ${!!props.isRightAligned &&
          css`
            left: auto;
            right: -6px;
          `}

          transition: background-color ${styleConstants.transitionSpeed
            .fast} ease-out;
          svg path {
            transition: stroke ${styleConstants.transitionSpeed.fast} ease-out;
          }

          ${props.design === CloseButtonDesigns.DarkOnLight &&
          css`
            &:hover {
              background-color: ${themeConstants.colors.cta};
              svg path {
                stroke: ${styleConstants.colors.white};
              }
            }
          `}
          ${props.design === CloseButtonDesigns.LightOnDark &&
          css`
            svg path {
              stroke: ${styleConstants.colors.white};
            }
            &:hover {
              background-color: ${styleConstants.colors.white};
              svg path {
                stroke: ${themeConstants.colors.cta};
              }
            }
          `}
          ${props.design === CloseButtonDesigns.RedLightOnDark &&
          css`
            svg path {
              stroke: ${styleConstants.colors.white};
            }
            &:hover {
              background-color: ${styleConstants.colors.white};
              svg path {
                stroke: ${styleConstants.colors.red};
              }
            }
          `}
          ${props.design === CloseButtonDesigns.DisabledDarkOnLight &&
          css`
            svg path {
              stroke: ${styleConstants.colors.blue_opacity};
            }
          `}
        `}
      >
        <SvgClose
          id={props.id ? props.id : 'closeIcon'}
          data-testid={props.id ? props.id : 'closeIcon'}
          css={css`
            transform: scale(1.5);
          `}
        />
      </div>
    </div>
  )
}

export default CloseButton
